import { styled, v2Colors } from 'theme';

const AvatarButton = styled('button', {
  // Reset
  appearance: 'none',
  boxSizing: 'border-box',
  lineHeight: '1',
  outline: 'none',
  padding: '0',
  userSelect: 'none',
  WebkitTapHighlightColor: 'rgba(0,0,0,0)',
  backgroundColor: 'transparent',

  // Custom
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid $border2',
  borderRadius: '$full',
  width: '44px',
  height: '44px',
  fontSize: '$sm',
  letterSpacing: '$wide',
  color: '$secondaryGrey',
  transition: 'all 200ms ease',
  '&:hover': {
    backgroundColor: '$violet100',
    color: '$primary',
  },
  '&:focus': {
    boxShadow: '$focus',
  },
  '&:focus:not(:focus-visible)': {
    boxShadow: 'none',
  },

  variants: {
    /**
     * The mockup's `.avatar`: a 34px tinted circle. The mockup's literal
     * #DDD4F0 border is $violet200 (#dfd8f0) to within a rounding error, so
     * no new entry in v2Tokens is needed for it.
     */
    v2: {
      true: {
        width: '34px',
        height: '34px',
        borderColor: '$violet200',
        backgroundColor: '$violet100',
        color: v2Colors.purple600,
        '&:hover': {
          backgroundColor: '$violet200',
          color: v2Colors.purple600,
        },
      },
    },
  },
});

export default AvatarButton;
